export default __webpack_public_path__ + "static/media/yearly-horoscope.9d9e0a3c.jpg";